import { CreateThemeInput } from 'kl-b2c-ui-kit';

export const light: CreateThemeInput = {
    palette: {
        titleHighlight: '#96dfa5',
        headerBackground: '#21272f',
        background: '#21272f',
        menuBackground: '#21272f',
        text: {
            secondary: '#999999',
            primary: '#1d1d1b',
            disabled: 'rgba(255, 255, 255, 0.6)',
        },
        black: '#1d1d1b',
        white: '#fff',
        teal: '#29CCB1',
        gray: {
            100: '#000000',
            200: '#666666',
            300: '#999999',
            400: '#aeaeae',
            500: '#cccccc',
            600: '#f2f2f2',
            700: 'rgba(41, 77, 117, 0.09)',
        },
        precisionBlue: '#29ccb1',
        green: '#00A88E',
    },
    shadows: {
        dropdown: '0 8px 16px 0px rgba(0, 0, 0, 0.2)',
    },
    breakpoints: {
        values: {
            xs: 767,
            sm: 1279,
            md: 1439,
        },
    },
    media: {
        xs: 'max-width: 767px',
        sm: 'max-width: 1023px',
        md: 'max-width: 1439px',
        lg: 'max-width: 1919px',
        mobile: 'min-width: 768px',
        tablet: 'min-width: 1024px',
        bigTablet: 'min-width: 1440px',
        superBigTablet: 'min-width: 1920px',
    },
    commonTypography: {
        fontFamily: 'Kaspersky Sans Display',
    },
    shape: {
        headerHeight: '64px',
        borderRadius: {
            button: 8,
            checkbox: 4,
            textField: 8,
        },
        borderWidth: {
            textField: 1,
            checkbox: 1,
            loader: 5,
        },
        baseSpacing: 2,
        checkbox: {
            baseSpacing: 4,
        },
        textField: {
            padding: 12,
        },
    },
    animation: {
        base: 'all 0.5s ease',
    },
    typography: {
        h1: {
            fontSize: 90,
        },
        h2: {
            fontSize: 32,
            lineHeight: 36,
            fontWeight: 500,
        },
        h3: {
            fontSize: 21,
            lineHeight: 24,
            fontWeight: 500,
        },
        subH4: {
            fontSize: 24,
        },
        p1: {
            fontSize: 16,
            lineHeight: 18,
            fontWeight: 400,
        },
        textField: {
            fontSize: 14,
        },
    },
};
